import React from 'react'

const SocialFacebookIcon = (
  <>
    <path
      d="M20.0002 39.1663C30.5856 39.1663 39.1668 30.5851 39.1668 19.9997C39.1668 9.41422 30.5856 0.833008 20.0002 0.833008C9.41471 0.833008 0.833496 9.41422 0.833496 19.9997C0.833496 30.5851 9.41471 39.1663 20.0002 39.1663Z"
      fill="#1877F2"
    />
    <path
      d="M27.4612 25.5393L28.3112 19.9993H22.9953V16.4043C22.9953 14.8885 23.7378 13.411 26.1187 13.411H28.5353V8.69434C27.1164 8.46471 25.6826 8.33938 24.2453 8.31934C19.867 8.31934 17.0053 10.9727 17.0053 15.7768V19.9993H12.1387V25.5393H17.0053V38.9327C18.9899 39.2438 21.0108 39.2438 22.9953 38.9327V25.5393H27.4612Z"
      fill="white"
    />
  </>
)

export default SocialFacebookIcon
